import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { translateText } from '../../../language'
import { isDefined, notDefined } from '../../../utils'

export const TranslatableTypography = (props) => {
  const { t, i18n } = useTranslation()
  const { data, text, children } = props
  let value = isDefined(data) ? translateText(data, i18n) : undefined
  value = (isDefined(text) && notDefined(value)) ? t(text) : value
  value = isDefined(value) ? value : t(children)

  return (
    <Typography {...props}>
      {value}
    </Typography>
  )
}
